module.exports = __webpack_public_path__ + "static/media/arrow_back-24px.3bd6d7e4.svg";